export const CfopInitial = {
  ENTRY_STATE: '1',
  ENTRY_INTERSTATE: '2',
  ENTRY_INTERNATIONAL: '3',
  EXIT_STATE: '5',
  EXIT_INTERSTATE: '6',
  EXIT_INTERNATIONAL: '7',
};

export const EntryCfop = [
  CfopInitial.ENTRY_STATE,
  CfopInitial.ENTRY_INTERSTATE,
  CfopInitial.ENTRY_INTERNATIONAL,
];

export const ExitCfop = [
  CfopInitial.EXIT_STATE,
  CfopInitial.EXIT_INTERSTATE,
  CfopInitial.EXIT_INTERNATIONAL,
];
